var map = {
	"./1.png": 1499,
	"./10.png": 1500,
	"./2.png": 1501,
	"./3.png": 1502,
	"./4.png": 1503,
	"./5.png": 1504,
	"./6.png": 1505,
	"./7.png": 1506,
	"./8.png": 1507,
	"./9.png": 1508,
	"./answer.png": 807,
	"./background1.png": 806,
	"./background2.png": 805,
	"./background3.png": 804,
	"./background4.png": 803,
	"./ch1.png": 808,
	"./che1.png": 495,
	"./che2.png": 798,
	"./che3.png": 801,
	"./che4.png": 796,
	"./che5.png": 799,
	"./che6.png": 802,
	"./che7.png": 797,
	"./che8.png": 800,
	"./che9.png": 1509,
	"./complete.png": 795
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;